function saveCartItems(apply_existing, formName, redirect_url) {
    $.ajax({
        url:$(document.body).data('base') + '/ajax/set-cart-data.php',
        type:'POST',
        data:{'exists': apply_existing},
        success: function (response) {
            response = JSON.parse(response);
            
            if (response.status == 'success') {
                window.location.href = $('form[name="' + formName + '"]').attr('next') ? $('form[name="' + formName + '"]').attr('next') : redirect_url;
            }
        }
    });
}

$(document).ready(function(){
    var loginFormName = 'login_form';
    var registerFormName = 'register_form';
    var forgotPasswordFormName = 'forgot_password_form';
    var resetPasswordFormName = 'reset_password_form';
    var passwordMinLength = 7;
    var formErrorClass = 'form__label--error';

    /**
     * Resets the information links when you click on another one.
     */
    function resetInformationLinks()
    {
        $('.form__information--link').each(function() {
            if($(this).attr('default')) {
                $(this).attr('form', $(this).attr('default'));

                if('register' == $(this).attr('default')) {
                    $(this).text('Register');
                }

                if('forgot-password' == $(this).attr('default')) {
                    $(this).text('Forgot Password');
                }

                $(this).removeAttr('default');
            }
        });
    }

    /**
     * Toggles the different form displays
     */
    $(document).on('click', '.form__information--link', function(event) {
        event.preventDefault();

        var form = $(this).attr('form');

        resetInformationLinks();

        if('register' == form) {
            $('div.login__forgotten-wrap').hide();
            $(this).parents('form').addClass('form--hide');
            $('form[name="' + registerFormName + '"]').removeClass('form--hide');
            $('h1[for="form"]').text('Register');
        }

        if('forgot-password' == form) {
            $(this).parents('form').addClass('form--hide');
            $('div.login__forgotten-wrap').show();
            $('form[name="' + forgotPasswordFormName + '"]').removeClass('form--hide');
            $('h1[for="form"]').text('Forgot Password');
        }

        if('login' == form) {
            $('div.login__forgotten-wrap').hide();
            $(this).parents('form').addClass('form--hide');
            $('form[name="' + loginFormName + '"]').removeClass('form--hide');
            $('h1[for="form"]').text('Login');
        }
    });

    /**
     * Login Form Validation
     */
    $('form[name="' + loginFormName + '"]').validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            password: {
                required: true,
                minlength: passwordMinLength,
            }
        },
        errorPlacement: function(error, element) {
        },
        submitHandler: function() {
            var form_data = $('form[name="' + loginFormName + '"]').serialize();
            
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/login.php',
                data: form_data,
                success: function(response) {
                    response = JSON.parse(response);
                    
                    if (response.status != 'success') {
                        swal('Error',response.message, 'error');
                        return;
                    }
                    
                    if (response.status == 'success') {
                        
                        swal({
                            title: "",
                            text: response.message,
                            type: response.status,
                            confirmButtonColor: "#f15a24",
                            showCancelButton: false,
                            confirmButtonText: "Ok",
                            closeOnConfirm: false,
                        }, function() {
                            var apply_existing = false;
                            
                            $.ajax({
                                url:$(document.body).data('base') + '/ajax/check-existing-cart.php',
                                type:'POST',
                                success: function(existingResponse) {
                                    existingResponse = JSON.parse(existingResponse);
                                    var existing_items = existingResponse.exists;
                                    
                                    if (existing_items) {
                                        swal({
                                            title:'',
                                            text:'Saved cart items found, apply these to current basket?',
                                            type:'info',
                                            showCancelButton: true,
                                            confirmButtonColor: "#f15a24",
                                            confirmButtonText: "Yes",
                                            cancelButtonText: "No",
                                            closeOnConfirm: true,
                                            closeOnCancel: true
                                        }, function (isConfirm) {
                                            if (isConfirm) {
                                                apply_existing = true;
                                            }
                                            
                                            saveCartItems(apply_existing, loginFormName, response.redirect_url);
                                        });
                                    } else {
                                        saveCartItems(false, loginFormName, response.redirect_url);
                                    }
                                },
                                error: function() {
                                    swal('Oops..', 'Sorry, there was an error logging into your account.', 'error');
                                    console.log('Ajax request not received');
                                }
                            });
                            
                        })
                    }
                },
                error: function(response) {
                    swal('Oops..', 'Sorry, there was an error logging into your account.', 'error');
                    console.log('Ajax request not received');
                }
            });
            
            return false;
        }
    });

    /**
     * Register Form Validation
     */
    $('form[name="' + registerFormName + '"]').validate({
        onkeyup: false,
        onclick: false,
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                required: true,
                email: true,
                uniqueEmail: true
            },
            confirm_email: {
                required: true,
                email: true,
                uniqueEmail: true,
                equalTo: '#core_email'
            },
            postcode: {
                required: true
            },
            address_line_1: {
                required: true
            },
            town: {
                required: true
            },
            county: {
                required: true
            },
            phone_number: {
                required: true
            },
            password: {
                required: true,
                minlength: passwordMinLength
            },
            password_confirm: {
                required: true,
                equalTo: '#password',
                matchedPassword: true
            }
        },
        errorPlacement: function(error, element) {
            if('form__information' == element.prev().attr('class')) {
                element.prev().remove();
            }
            if(element.is("#core_email")) {
                swal('','There is already an account registered to this e-mail address, please login or reset your password.','error')
            }
        },
        submitHandler: function() {
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/register.php',
                data: $('form[name="' + registerFormName + '"]').serialize(),
                success: function(response) {
                    response = JSON.parse(response);
                    if(response.status == 'success') {
                        swal({
                            title: '',
                            text: response.message,
                            type: response.status,
                            confirmButtonColor: "#f15a24"
                        }, function() {
                            if(response.status == 'success') {
                                window.location.href = $('form[name="' + registerFormName + '"]').attr('next') ? $('form[name="' + registerFormName + '"]').attr('next') : response.redirect_url;
                            }
                        });
                        return false;
                    } else {
                        swal({
                            title: '',
                            text: response.message,
                            type: response.status,
                            confirmButtonColor: "#f15a24"
                        });
                    }
                },
                error: function() {
                    swal('Oops...', 'Sorry we couldn\'t register your account right now', 'error');
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });

    /**
     * Forgot Password Form Validation
     */
    $('form[name="' + forgotPasswordFormName + '"]').validate({
        errorClass: formErrorClass,
        rules: {
            email: {
                required: true,
                email: true,
            }
        },
        errorPlacement: function(error, element) {
            error.insertBefore(element);
            element.removeClass(formErrorClass);
        },
        submitHandler: function() {

            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/forgot-password.php',
                data: $('form[name="' + forgotPasswordFormName + '"]').serialize(),
                success: function(response) {
                    response = JSON.parse(response);

                    swal({
                        title: response.status,
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    });
                },
                error: function() {
                    swal('Oops..', 'Sorry, there was an error resetting your password', 'error');
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });

    /**
     * Reset Password Form Validation
     */
    $('form[name="' + resetPasswordFormName + '"]').validate({
        errorClass: formErrorClass,
        rules: {
            password: {
                required: true,
                minlength: passwordMinLength
            },
            password_confirm: {
                required: true,
                equalTo: '#password',
                matchedPassword: true
            }
        },
        errorPlacement: function(error, element) {
            error.insertBefore(element);
            element.removeClass(formErrorClass);
        },
        submitHandler: function() {
            $.ajax({
                type: 'POST',
                url: $(document.body).data('base') + '/ajax/reset-password.php',
                data: $('form[name="' + resetPasswordFormName + '"]').serialize(),
                success: function(response) {
                    response = JSON.parse(response);
                    swal({
                        title: '',
                        text: response.message,
                        type: response.status,
                        confirmButtonColor: "#f15a24"
                    }, function() {
                        if(response.status == 'success') {
                            window.location.href = $('form[name="' + registerFormName + '"]').attr('next') ? $('form[name="' + registerFormName + '"]').attr('next') : response.redirect_url;
                        }
                    });
                },
                error: function() {
                    swal('Oops..', 'Sorry, there was an error resetting your password', 'error');
                    console.log('Ajax request not received');
                }
            });

            return false;
        }
    });
});